import { memo } from 'react';
import { SpeakerTimelineTrack } from './useSceneTracks';

const SceneOptionsSpeakersSubMenu = ({
  tracks = [],
  onToggleTrack
}: {
  tracks: SpeakerTimelineTrack[];
  onToggleTrack: (id: string) => void;
}) => {
  return (
    <div className="py-1" onClick={e => e.stopPropagation()}>
      {tracks.map(track => (
        <button
          key={track.id}
          className="flex w-full items-center gap-3 px-1.5 py-1 pl-3 text-sm hover:bg-slate-50"
          onClick={e => {
            e.stopPropagation();
            onToggleTrack(track.name);
          }}
        >
          <span className="w-4">{track.selected ? '✓' : ''}</span>
          <span
            className={`max-w-36 rounded-full px-3 py-1 text-xs ${track.lightBgColor} ${track.color} truncate`}
            title={track.name}
          >
            {track.name}
          </span>
        </button>
      ))}
    </div>
  );
};

export default memo(SceneOptionsSpeakersSubMenu);
